import * as React from 'react';
import { createContext, useContext, useState } from 'react';

export interface ClaimModalOpenContextType {
  openClaimModal: boolean;
  isWalletOnly: boolean;
  isDisconnect: boolean;
  setIsDisconnect: React.Dispatch<React.SetStateAction<boolean>>;
  setIsWalletOnly: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenClaimModal(f: boolean | ((prev: boolean) => boolean)): void;
}

const ClaimModalContext = createContext<ClaimModalOpenContextType>({} as ClaimModalOpenContextType);

export const ClaimModalOpenProvider = ({ children }: { children: React.ReactNode }) => {
  const [openClaimModal, setOpenClaimModal] = useState<boolean>(false);
  const [isWalletOnly, setIsWalletOnly] = useState<boolean>(false);
  const [isDisconnect, setIsDisconnect] = useState<boolean>(false);

  return (
    <ClaimModalContext.Provider
      value={{
        openClaimModal,
        setOpenClaimModal,
        isDisconnect,
        setIsDisconnect,
        isWalletOnly,
        setIsWalletOnly
      }}
    >
      {children}
    </ClaimModalContext.Provider>
  );
};

export const useOpenClaimModal = (): ClaimModalOpenContextType => {
  const context = useContext(ClaimModalContext);

  if (!context) {
    throw new Error('useOpenClaimModal must be used within a ClaimModalOpenProvider');
  }

  return context;
};
